import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";
/**
 * 项目申报后台服务接口
 */
const declareProjectService = {};
let base_url = '/establish-api'
/**
 * 发送短信验证码
 * @param smsPhone 短信手机号
 * @returns {*}
 */
declareProjectService.sendQuerySmsCode = function (smsPhone) {
    return request({
        url: "/project-announcement/send-query-sms",
        method: "get",
        params: {
            smsPhone: smsPhone
        },
        baseURL: base_url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    });

}
/**
 * 查询项目公示列表
*/
declareProjectService.queryProjectAnnouncementList = function (queryQo) {
    return request({
        url: "/project-announcement/project-announcement-list",
        method: "post",
        data: queryQo,
        baseURL: base_url
    });

}
export default declareProjectService;
